import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { stringify } from 'qs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { config } from '../../../../config';
import { Slod, PaginatedSlod } from '../slods/slod.model';
import { TokenService } from '../../services';

@Injectable()
export class SlodService {
  constructor(private http: HttpClient, private token: TokenService) { }

  get(terms?: object, page?: number, format?: string): Observable<PaginatedSlod> {
    return this.http
      .get<PaginatedSlod>(`${config.apiLocation}/v1/slods?${stringify({ terms, page, format })}`)
      .map(res => res);
  }

  create(debt_id: string, data: {}): Observable<Slod> {
    return this.http
      .post<{ data: Slod }>(`${config.apiLocation}/v1/debts/${debt_id}/slods`, data)
      .map(res => res.data);
  }

  update(debt_id: string, slod_id: string, data: {}): Observable<Slod> {
    return this.http
      .patch<{ data: Slod }>(`${config.apiLocation}/v1/debts/${debt_id}/slods/${slod_id}`, data)
      .map(res => res.data);
  }

  updateStatus(debt_id: string, slod_id: string, data: {}): Observable<Slod> {
    return this.http
      .patch<{ data: Slod }>(`${config.apiLocation}/v1/debts/${debt_id}/slods/${slod_id}/update-status`, data)
      .map(res => res.data);
  }

  downloadPreviewUrl(debt_id: string, slod_id: string): Observable<string> {
    return this.token
      .getAccessToken()
      .map(token => `${config.apiLocation}/v1/debts/${debt_id}/slods/${slod_id}/preview?token=${token}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/slods/slod.service.ts